/* eslint-disable max-len */
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

/**
 *
 */
EDC.Games.CountingItems.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.SoundsSorting.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.coordinates = [
    { x: 211, y: 700 },
    { x: 260, y: 300 },
    { x: 485, y: 600 },
    { x: 795, y: 687 },
    { x: 750, y: 280 },
    { x: 1300, y: 250 },
    { x: 1200, y: 583 },
    { x: 1786, y: 420 },
    { x: 1650, y: 740 },
  ];
  this.numbers = [];
  this.numbersWidth = 1200;
  this.numbersHeight = 160;
  this.panelMask = null;
  this.items = [];
  this.itemsContainer = null;
};
/**
 *
 */
EDC.Games.CountingItems.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.CountingItems.Scenes.Main.prototype.constructor = EDC.Games.CountingItems.Scenes.Main;
/**
 *
 */
EDC.Games.CountingItems.Scenes.Main.prototype.create = function () {
  this.initialize();

  this.add.sprite(this.game.config.width / 2, 1030, 'title');
  this.itemsContainer = this.add.container(0, 0);

  this.placeItems();

  this.addNumbersPanel();
  this.addNumbers();

  this.createBasicUI();
};
/**
 *
 */
EDC.Games.CountingItems.Scenes.Main.prototype.getRandomValueFromArray = function (targetArray) {
  const rndIndex = Math.floor(Math.random() * targetArray.length);
  const res = targetArray.splice(rndIndex, 1);
  return res[0];
};
/**
 *
 */
EDC.Games.CountingItems.Scenes.Main.prototype.placeItems = function () {
  const tmpCoordinates = this.coordinates.map(element => element);
  const neededCount = this.gameConfig.sets[this.difficulty].iterations[this.iteration].correct;
  for (let i = 0; i < neededCount; i++) {
    const rndPlace = this.getRandomValueFromArray(tmpCoordinates);
    const itemSprite = this.add.sprite(rndPlace.x, rndPlace.y, `fish-${i}`);
    itemSprite.setAlpha(0);
    this.items.push(itemSprite);
    this.itemsContainer.add(itemSprite);
    this.tweens.add({
      targets: itemSprite,
      alpha: 1,
      duration: 600,
      ease: 'Linear',
    });

    const rndDistance = 10 + Math.floor(Math.random() * 10);
    const rndDuration = 1700 + Math.floor(Math.random() * 1000);
    this.tweens.add({
      targets: itemSprite,
      y: itemSprite.y - rndDistance,
      duration: rndDuration,
      ease: 'Sine.easeInOut',
      yoyo: true,
      repeat: -1,
    });
  }
};
/**
 *
 */
EDC.Games.CountingItems.Scenes.Main.prototype.addNumbersPanel = function () {
  const x = (this.game.config.width - this.numbersWidth) / 2;
  const y = 820;
  const g = this.add.graphics();
  g.fillStyle(0x000000, 0.6);
  g.fillRoundedRect(x, y, this.numbersWidth, this.numbersHeight, 60);
  this.panelMask = g.createGeometryMask();
};
/**
 *
 */
EDC.Games.CountingItems.Scenes.Main.prototype.addNumbers = function () {
  // current iteration data
  const cid = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const slotWidth = this.numbersWidth / cid.data.length;
  const neededHeight = (this.numbersHeight * 80) / 100;
  const sx = (this.game.config.width - this.numbersWidth) / 2;

  for (let i = 0; i < cid.data.length; i++) {
    const x = sx + slotWidth * i + slotWidth / 2;
    const numberContainer = this.add.container(x + slotWidth * cid.data.length, 820 + this.numbersHeight / 2);
    numberContainer.setData('placeX', x);
    const value = cid.data[i];
    const numberSprite = this.add.sprite(0, 0, `number-${value}`);
    const neededScale = neededHeight / numberSprite.height;
    numberSprite.setScale(neededScale, neededScale);

    numberContainer.add(numberSprite);
    const bounds = numberContainer.getBounds();
    numberContainer.setSize(bounds.width, bounds.height);
    this.numbers.push(numberContainer);

    const markAnim = new AnswerMark(this, numberContainer).setScale(0.35);
    numberContainer.setData('markAnim', markAnim);
    numberContainer.setData('value', value);
    numberContainer.setData('index', i);
    numberContainer.setData('slotWidth', slotWidth);

    numberContainer.setInteractive();
    numberContainer.on('pointerup', this.numberClick.bind(this, numberContainer), this);
    this.cursorManager.setDefaultDraggableEvents(numberContainer);
    numberContainer.setMask(this.panelMask);
    this.tweens.add({
      targets: numberContainer,
      x: numberContainer.getData('placeX'),
      duration: 600,
      ease: 'Back.easeOut',
    });
  }
};
/**
 *
 */
EDC.Games.CountingItems.Scenes.Main.prototype.numberClick = function (targetContainer) {
  targetContainer.removeInteractive();
  this.tweens.add({
    targets: targetContainer,
    scaleX: 0.9,
    scaleY: 0.9,
    duration: 150,
    ease: 'Linear',
    yoyo: true,
    onComplete: function (target) {
      if (target.getData('value') !== this.gameConfig.sets[this.difficulty].iterations[this.iteration].correct) {
        this.playWrong();
        target.removeInteractive();
        this.cursorManager.resetCursor();
        target.getAt(0).setTint(0xff0000);
        target.getData('markAnim').showMark(false, () => {});
      } else {
        this.playCorrect();
        this.cursorManager.resetCursor();
        target.removeInteractive();
        target.getData('markAnim').showMark(true, () => {
          this.nextIteration();
        });
      }
    }.bind(this, targetContainer),
  });
};
/**
 *
 */
EDC.Games.CountingItems.Scenes.Main.prototype.nextIteration = function () {
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.destroyNumbers();
    this.destroyItems();
  }
};
/**
 *
 */
EDC.Games.CountingItems.Scenes.Main.prototype.destroyNumbers = function () {
  for (let i = 0; i < this.numbers.length; i++) {
    this.tweens.add({
      targets: this.numbers[i],
      x: this.numbers[i].x - this.numbers[i].getData('slotWidth') * this.numbers.length,
      duration: 600,
      ease: 'Back.easeIn',
      easeParams: [1.2],
      onComplete: function (index) {
        this.numbers[index].destroy();
        if (index >= this.numbers.length - 1) {
          this.numbers = [];
          this.addNumbers();
        }
      }.bind(this, i),
    });
  }
};
/**
 *
 */
EDC.Games.CountingItems.Scenes.Main.prototype.destroyItems = function () {
  for (let i = 0; i < this.items.length; i++) {
    this.tweens.add({
      targets: this.items[i],
      alpha: 0,
      duration: 600,
      ease: 'Linear',
      onComplete: function (index) {
        this.items[index].destroy();
        if (index >= this.items.length - 1) {
          this.items = [];
          this.placeItems();
        }
      }.bind(this, i),
    });
  }
};

export default EDC.Games.CountingItems.Scenes.Main;
